module.exports = __webpack_public_path__ + "icomoon.svg?d6d41e46a8aa5338f3a18428a42a6c54";